// ** IMPORTANT **: Keep in sync with functions/src/index.ts inferNameFromEmail
const inferNameFromEmail = (email: string): {
    firstName?: string,
    lastName?: string,
} => {
    const localPart = email.split('@')[0] || '';
    const normalized = localPart
        .replace(/\+/g, '.')
        .replace(/[_-]/g, '.')
        .replace(/[0-9]+/g, '.')
        .replace(/\.+/g, '.')
        .replace(/^\./, '')
        .replace(/\.$/, '');
    const tokens = normalized
        .split('.')
        .map((token) => token.trim())
        .filter((token) => token.length > 0);
    const normalizeToken = (token: string): string => (
        `${token.substring(0, 1).toUpperCase()}${token.substring(1).toLowerCase()}`
    );
    if (tokens.length === 0) return {};
    if (tokens.length === 1) {
        return {
            firstName: normalizeToken(tokens[0]),
        };
    }
    return {
        firstName: normalizeToken(tokens[0]),
        lastName: normalizeToken(tokens.slice(1).join(' ')),
    };
};

export default inferNameFromEmail;
